import { render, staticRenderFns } from "./APIClientManagement.vue?vue&type=template&id=35e8da6e&"
import script from "./APIClientManagement.vue?vue&type=script&lang=js&"
export * from "./APIClientManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports